import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { FaPlus } from 'react-icons/fa';

export const ParticipantRestrictivePracticeCreateButton = (props: ChakraV3.ButtonProps) => {
  return (
    <ChakraV3.Button
      w='full'
      h='full'
      rounded='2xl'
      borderWidth='2px'
      borderStyle='dashed'
      color='gray.400'
      bg='white'
      variant='outline'
      _hover={{
        borderColor: 'gray.400',
        color: 'gray.500',
      }}
      fontSize='2xl'
      {...props}
    >
      <FaPlus />
      Add restrictive practice
    </ChakraV3.Button>
  );
};
